<transition :appear="true"
            :css="false"
            @enter="openProcessingPortal()"
            @leave="removeBackdrop()">
    <div class="m-spinner">
        <portal :target-el="spinnerElement"
                v-if="initialized">
            <div ref="spinnerWrap"
                 class="m-spinner__wrap"
                 :class="{
                    'm--is-processing': processing,
                    'm--is-dark': skin === 'dark',
                    'm--is-light': skin === 'light',
                    'm--is-lighter': skin === 'lighter' }">
                <div aria-hidden="true"
                     class="m-spinner__icon"
                     :class="{ 'm--is-small' : size === 'small'}"></div>
                <h2 class="m-spinner__title"
                    v-if="titleMessage || (title && processing) || title">
                    <template v-if="titleMessage">{{ titleMessage }}</template>
                    <template v-else-if="title && processing">{{$i18n.translate('m-spinner:processing')}}</template>
                    <template v-else-if="title">{{$i18n.translate('m-spinner:loading')}}</template>
                </h2>
                <p class="m-spinner__description"
                   v-if="description || descriptionMessage">
                    <template v-if="descriptionMessage">{{ descriptionMessage }}</template>
                    <template v-else>{{ $i18n.translate('m-spinner:description') }}</template>
                </p>
            </div>
        </portal>
        <div ref="spinnerContainer"
             v-if="!processing"></div>
    </div>
</transition>
